module.exports = __webpack_public_path__ + "static/media/rolling-panda.e6f5cc3d.jpg";